<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <panel-title icon="mdi-face-agent" :title="$t('DESTEK.TITLE')" :desc="$t('DESTEK.SUB_TITLE')" />
      </v-col>
      <v-col cols="12" offset-lg="3" lg="9" class="py-0 order-1 order-lg-0">
        <div class="d-flex justify-space-between align-center">
          <div>
            <v-chip v-show="secilenTalepler.length > 0" small color="blue mr-2 font-weight-medium" dark>
              {{ $t("DESTEK.SELECTED_TICKETS", { COUNT: secilenTalepler.length }) }}
            </v-chip>
          </div>
          <div>
            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-on="on" v-bind="attrs" dark class="d-flex align-center pr-2 text-capitalize" color="grey darken-4" rounded small :loading="talepDurumlarLoading">
                  {{ $t("DESTEK.MASS_SELECTION") }}
                  <v-icon size="20" class="ml-2">mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-card v-if="secilenTalepler.length > 0">
                <v-btn small block depressed class="d-flex justify-start text-capitalize elevation-0 rounded-0" @click="durumlariDegis(1)">
                  <v-icon color="grey darken-4" size="20" left>mdi-clock</v-icon>
                  {{ $t("DESTEK.MASS_SELECTING_STATUSES.SET_AS_PENDING") }}
                </v-btn>
                <v-btn small block depressed class="d-flex justify-start text-capitalize elevation-0 rounded-0" @click="durumlariDegis(2)">
                  <v-icon color="grey darken-4" size="20" left>mdi-comment-processing</v-icon>
                  {{ $t("DESTEK.MASS_SELECTING_STATUSES.SET_AS_IN_PROGRESS") }}
                </v-btn>
                <v-btn small block depressed class="d-flex justify-start text-capitalize elevation-0 rounded-0" @click="durumlariDegis(3)">
                  <v-icon color="grey darken-4" size="20" left>mdi-comment-check</v-icon>
                  {{ $t("DESTEK.MASS_SELECTING_STATUSES.SET_AS_ANSWERED") }}
                </v-btn>
                <v-btn small block depressed class="d-flex justify-start text-capitalize elevation-0 rounded-0" @click="durumlariDegis(4)">
                  <v-icon color="grey darken-4" size="20" left>mdi-checkbox-multiple-marked-circle</v-icon>
                  {{ $t("DESTEK.MASS_SELECTING_STATUSES.SET_AS_CLOSED") }}
                </v-btn>
              </v-card>
              <v-alert v-else :icon="false" type="info" class="py-2 px-2 mb-0 text-subtitle-2">
                <v-icon size="20">mdi-information</v-icon>
                {{ $t("DESTEK.SELECTION_ALERT_INFO") }}
              </v-alert>
            </v-menu>
          </div>
        </div>
      </v-col>
      <v-col cols="24" lg="3" class="order-0 order-lg-1">
        <v-row no-gutters>
          <v-col cols="12" sm="6" lg="12" class="pr-sm-2 pr-lg-0">
            <v-card>
              <v-toolbar dense color="grey darken-4" class="text-body-2 font-weight-medium" dark>
                <v-icon left size="20">mdi-clipboard-edit-outline</v-icon>
                {{ $t("DESTEK.APPLICATION_STATUSES_TITLE") }}
              </v-toolbar>
              <v-subheader> {{ $t("DESTEK.APPLICATION_STATUSES_SUB_TITLE") }}</v-subheader>
              <v-list dense>
                <v-list-item-group v-model="statusType" mandatory :color="groupColor()">
                  <v-list-item :value="null">
                    <v-list-item-icon class="mx-3">
                      <v-icon color="grey--text text--darken-2">mdi-check-all</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="grey--text text--darken-2">{{ $t("DESTEK.STATUSES.ALL") }} </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :value="1">
                    <v-list-item-icon class="mx-3">
                      <v-icon color="amber darken-3">mdi-clock</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="amber--text text--darken-3">{{ $t("DESTEK.STATUSES.PENDING") }} </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :value="2">
                    <v-list-item-icon class="mx-3">
                      <v-icon color="light-blue darken-3">mdi-comment-processing</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="light-blue--text text--darken-3">{{ $t("DESTEK.STATUSES.IN_PROGRESS") }} </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :value="3">
                    <v-list-item-icon class="mx-3">
                      <v-icon color="success darken-1">mdi-comment-check</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="success--text text--darken-1">{{ $t("DESTEK.STATUSES.ANSWERED") }} </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :value="4">
                    <v-list-item-icon class="mx-3">
                      <v-icon color="black">mdi-checkbox-multiple-marked-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="black--text">{{ $t("DESTEK.STATUSES.CLOSED") }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- 1: beklemede, 2: işleme alındı, 3: cevaplandı, 4: kapatıldı -->
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>
          <v-col cols="12" class="d-sm-none d-lg-block">
            <div class="my-4"></div>
          </v-col>
          <v-col cols="12" sm="6" lg="12" class="pl-sm-2 pl-lg-0">
            <v-card>
              <v-toolbar dense color="grey darken-4 text-body-2 font-weight-medium" dark>
                <v-icon size="20" left>mdi-calendar</v-icon>
                {{ $t("DESTEK.SORT_BY_DATE_TITLE") }}
              </v-toolbar>
              <v-subheader> {{ $t("DESTEK.SORT_BY_DATE_SUB_TITLE") }}</v-subheader>
              <div class="px-2 pb-2">
                <v-dialog ref="dialog" v-model="statusDateDialog" :return-value.sync="statusDate" width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="statusDate"
                        :label="$t('DESTEK.SORT_BY_DATE_LABEL')"
                        prepend-inner-icon="mdi-calendar"
                        hide-details
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="statusDate" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="statusDateDialog = false">{{ $t("DESTEK.DATEPICKER_CANCEL_BTN") }} </v-btn>
                    <v-btn text color="primary" @click="setStatusDate">{{ $t("DESTEK.DATEPICKER_OK_BTN") }}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </div>
            </v-card>
          </v-col>
        </v-row>

      </v-col>
      <v-col cols="24" lg="9" class="order-2 order-lg-2">
        <v-data-table
          checkbox-color="pink darken-1"
          v-model="secilenTalepler"
          :items="destekTalepleri"
          :page.sync="tableParams.page"
          :items-per-page="list.limit"
          :headers="yazilarTable.headers"
          :no-data-text="yazilarTable.noDataText"
          calculate-widths
          hide-default-footer
          id="ticketTable"
          class="elevation-1 mb-3"
          @page-count="tableParams.pageCount = $event"
          :loading="tableParams.listStatus"
          :loading-text="yazilarTable.loadingText"
          :server-items-length="destekTalepleriSayisi"
          show-select
        >
          <template v-slot:item.tickettype="{ item }">
            <span v-if="item.tickettype === 'P'">
              <v-chip small color="deep-purple darken-1" class="font-weight-medium" dark>{{ $t("DESTEK.TICKET_TYPES.PRODUCT_SUPPORT") }}</v-chip>
            </span>
            <span v-else-if="item.tickettype === 'O'">
              <v-chip small color="success darken-1" dark class="font-weight-medium">{{ $t("DESTEK.TICKET_TYPES.ORDER_SUPPORT") }}</v-chip>
            </span>
          </template>
          <template v-slot:item.ticketname="{ item }">
            <strong>{{ item.ticketname }}</strong>
          </template>
          <template v-slot:item.ticketdate="{ item }">
            {{ dateFormat(item.ticketdate) }}
          </template>
          <template v-slot:item.ticketpublish="{ item }">
            <v-tooltip v-if="item.ticketpublish === 1" bottom color="amber darken-3">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-on="on" v-bind="attrs" color="amber darken-3">mdi-clock</v-icon>
              </template>
              <span>{{ $t("DESTEK.STATUSES.PENDING") }}</span>
            </v-tooltip>
            <v-tooltip v-else-if="item.ticketpublish === 2" bottom color="light-blue darken-3">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-on="on" v-bind="attrs" color="light-blue darken-3">mdi-comment-processing</v-icon>
              </template>
              <span>{{ $t("DESTEK.STATUSES.IN_PROGRESS") }}</span>
            </v-tooltip>
            <v-tooltip v-else-if="item.ticketpublish === 3" bottom color="success darken-1">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-on="on" v-bind="attrs" color="success darken-1">mdi-comment-check</v-icon>
              </template>
              <span>{{ $t("DESTEK.STATUSES.ANSWERED") }}</span>
            </v-tooltip>
            <v-tooltip v-else-if="item.ticketpublish === 4" bottom color="black">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-on="on" v-bind="attrs" color="black">mdi-checkbox-multiple-marked-circle</v-icon>
              </template>
              <span>{{ $t("DESTEK.STATUSES.CLOSED") }}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.ticketcode="{ item }">
            <v-btn small color="grey darken-3" dark rounded @click="talepDetay(item.ticketcode)" :loading="talepDetayLoading">
              <v-icon left>mdi-comment-eye</v-icon>
              {{ $t("DESTEK.SHOW_BTN") }}
            </v-btn>
          </template>
        </v-data-table>
        <v-pagination v-model="pagination.page" :length="tableParams.pageCount" circle @input="pageClick"></v-pagination>
      </v-col>
    </v-row>
    <v-dialog v-model="talepDialog.dialog" scrollable @click:outside="closeTalepDialog" content-class="talep-dialog">
      <v-card>
        <v-card-title class="grey darken-4 px-4 py-4 d-flex flex-wrap justify-content-between align-center white--text">
          <div>
            <v-chip color="white" class="text-subtitle-1" label>
              <v-icon size="20" class="mr-2">mdi-message-reply-text</v-icon>
              <b class="mr-2">{{ aktifTalepData.username }}</b>
              - {{ aktifTalepData.ticketname }}
            </v-chip>
          </div>
          <v-spacer></v-spacer>
          <div>
            <span v-if="aktifTalepData.tickettype === 'P'">
              <v-chip color="deep-purple darken-1" label class="font-weight-medium rounded-0 rounded-tl-lg rounded-bl-lg pr-1" dark
                >{{ $t("DESTEK.SHOW_TICKET_DIALOG.TICKET_TYPE_PRODUCT") }}:</v-chip
              >
            </span>
            <span v-else-if="aktifTalepData.tickettype === 'O'">
              <v-chip color="success darken-1" label dark class="font-weight-medium rounded-0 rounded-tl-lg rounded-bl-lg pr-1"
                >{{ $t("DESTEK.SHOW_TICKET_DIALOG.TICKET_TYPE_ORDER") }}:</v-chip
              >
            </span>
            <span>
              <v-chip
                label
                dark
                v-if="aktifTalepData.tickettype === 'P'"
                color="deep-purple darken-1"
                class="rounded-0 rounded-tr-lg rounded-br-lg pl-2"
                @click="mesajRequestDialog(talepDetayData[talepDetayData.length - 1].request)"
              >
                <v-icon size="20" class="mr-1 pl-0">mdi-information</v-icon>{{ $t("DESTEK.SHOW_TICKET_DIALOG.TICKET_TYPE_PRODUCT_BTN") }}
              </v-chip>
              <v-chip
                label
                dark
                v-else-if="aktifTalepData.tickettype === 'O'"
                color="success darken-1"
                class="rounded-0 rounded-tr-lg rounded-br-lg pl-2"
                @click="mesajRequestDialog(talepDetayData[talepDetayData.length - 1].request)"
              >
                <v-icon size="20" class="mr-1 pl-0">mdi-information</v-icon>{{ $t("DESTEK.SHOW_TICKET_DIALOG.TICKET_TYPE_ORDER_BTN") }}
              </v-chip>
            </span>
          </div>
          <v-dialog v-model="talepDetayRequest.dialog" max-width="1000">
            <v-card scrollable>
              <v-card-title class="blue py-3 text-body-1 white--text">
                <span v-if="aktifTalepData.tickettype === 'P'">
                  {{ $t("DESTEK.SHOW_TICKET_DIALOG.TICKET_TYPE_DIALOG.TITLE_PRODUCT_TYPE") }}
                </span>
                <span v-else-if="aktifTalepData.tickettype === 'O'">
                  {{ $t("DESTEK.SHOW_TICKET_DIALOG.TICKET_TYPE_DIALOG.TITLE_ORDER_TYPE") }}
                </span>
              </v-card-title>
              <v-card-text>
                <div :key="key" v-for="(data, key) in talepDetayRequest.data">
                  {{ data }}
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small dark color="red darken-2" @click="talepDetayRequest.dialog = false">
                  <v-icon>mdi-close</v-icon>
                  {{ $t("DESTEK.SHOW_TICKET_DIALOG.TICKET_TYPE_DIALOG.CLOSE_BTN") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-title>
        <v-card-text ref="virtualScrollBody" class="overlay-dialog-card-text grey lighten-2 py-4">
          <v-overlay :absolute="true" :value="talepDialog.overlay" opacity="1" color="white">
            <div class="d-flex justify-center mb-5">
              <v-progress-circular indeterminate color="black" size="64"></v-progress-circular>
            </div>
            <div class="black--text text-body-1 font-weight-medium">
              {{ $t("DESTEK.SHOW_TICKET_DIALOG.LOADING_TICKET_DETAIL") }}
            </div>
          </v-overlay>
          <DynamicScroller :items="talepDetayData" :min-item-size="20">
            <template v-slot:default="{ item, index }">
              <v-card class="d-inline-block px-3 pt-3 pb-2" :min-width="350" elevation="1" color="blue" dark rounded="lg" v-if="item.class === 1">
                <div class="mb-2">
                  <v-chip label small color="blue darken-3">
                    <v-icon size="15" color="blue lighten-2" left>mdi-account</v-icon>
                    {{ aktifTalepData.username }}
                  </v-chip>
                </div>
                <div class="mb-3">
                  <div v-html="parseIt(item.message)"></div>
                </div>
                <div class="text-right text-caption">{{ dateFormat(item.date) }}</div>
              </v-card>
              <v-card class="d-inline-block px-3 pt-3 pb-2" :min-width="350" elevation="1" color="success" dark rounded="lg" v-if="item.class === 2">
                <div class="ticket-message-actions py-1 px-1">
                  <v-btn small icon @click="mesajDuzenleDialog(item.code, item.message)">
                    <v-icon size="18">mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn small icon v-show="index !== 0" @click="mesajKaldirDialog(item.code)">
                    <v-icon size="18">mdi-delete-outline</v-icon>
                  </v-btn>
                </div>
                <div class="mb-2">
                  <v-chip label small color="success darken-2">
                    <v-icon size="15" color="success lighten-1" left>mdi-account</v-icon>
                    {{ $t("DESTEK.SHOW_TICKET_DIALOG.MESSAGE_MANAGER_NAME") }}
                  </v-chip>
                </div>
                <div v-html="parseIt(item.message)"></div>
                <div class="text-right text-caption">{{ dateFormat(item.date) }}</div>
              </v-card>
            </template>
          </DynamicScroller>
        </v-card-text>
        <div class="grey lighten-2 px-5 py-4">
          <div class="d-flex flex-wrap justify-space-between align-end">
            <p class="pl-6 text-body-1 mb-0">
              <v-chip color="success" class="rounded-bl-0 rounded-br-0" dark label small>
                <v-icon left size="20">mdi-email-send</v-icon>
                <b>{{ $t("DESTEK.SHOW_TICKET_DIALOG.ANSWER_TO_MEMBER_TITLE") }}</b>
              </v-chip>
            </p>
            <div>
              <v-btn
                rounded
                small
                color="amber darken-3"
                class="mr-2 my-2"
                v-show="aktifTalepData.ticketpublish !== 1"
                @click="durumDegis(1)"
                :loading="talepDurumLoading[1]"
              >
                <v-icon class="mr-1" size="18">mdi-clock</v-icon>
                {{ $t("DESTEK.SHOW_TICKET_DIALOG.ACTIONS.SET_AS_PENDING") }}
              </v-btn>
              <v-btn
                rounded
                small
                color="light-blue darken-3"
                dark
                class="mr-2 my-2"
                v-show="aktifTalepData.ticketpublish !== 2"
                @click="durumDegis(2)"
                :loading="talepDurumLoading[2]"
              >
                <v-icon class="mr-1" size="18">mdi-comment-processing</v-icon>
                {{ $t("DESTEK.SHOW_TICKET_DIALOG.ACTIONS.SET_AS_IN_PROGRESS") }}
              </v-btn>
              <v-btn
                rounded
                small
                color="black"
                dark
                class="mr-5 my-2"
                v-show="aktifTalepData.ticketpublish !== 4"
                @click="durumDegis(4)"
                :loading="talepDurumLoading[4]"
              >
                <v-icon class="mr-1" size="18">mdi-checkbox-multiple-marked-circle</v-icon>
                {{ $t("DESTEK.SHOW_TICKET_DIALOG.ACTIONS.SET_AS_CLOSED") }}
              </v-btn>
            </div>
          </div>
          <v-card elevation="0" color="grey lighten-3" rounded="xl">
            <v-textarea v-model="talepDialog.message" outlined color="success" hide-details :placeholder="$t('DESTEK.SHOW_TICKET_DIALOG.ANSWER_TO_MEMBER_PLACEHOLDER')" rows="3">
              <template v-slot:append>
                <v-tooltip bottom color="success">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-on="on" v-bind="attrs" fab depressed color="success" dark @click="mesajGonder">
                      <v-icon size="30" style="position:relative;left:3px;">mdi-send</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("DESTEK.SHOW_TICKET_DIALOG.SEND_MESSAGE_BTN") }}</span>
                </v-tooltip>
              </template>
            </v-textarea>
          </v-card>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark color="red darken-4" rounded class="px-4" @click="closeTalepDialog()">
            <v-icon size="20" class="mr-1">mdi-window-close</v-icon>
            {{ $t("DESTEK.SHOW_TICKET_DIALOG.CLOSE_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mesajDuzenleData.dialog" max-width="400">
      <v-card>
        <v-card-title class="text-body-1 blue white--text py-4">
          <v-icon color="blue lighten-3" left size="22">mdi-pencil</v-icon>
          {{ $t("DESTEK.EDIT_MESSAGE_DIALOG.TITLE") }}
        </v-card-title>
        <v-card-text class="px-3 py-3">
          <v-textarea v-model="mesajDuzenleData.message" outlined hide-details color="blue"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-2" small dark @click="mesajDuzenleData.dialog = false">
            <v-icon size="18" class="mr-1">mdi-cancel</v-icon>
            {{ $t("DESTEK.EDIT_MESSAGE_DIALOG.CANCEL_BTN") }}
          </v-btn>
          <v-btn color="blue" small dark @click="mesajDuzenle" :loading="mesajDuzenleData.loading">
            <v-icon size="18" class="mr-1">mdi-check</v-icon>
            {{ $t("DESTEK.EDIT_MESSAGE_DIALOG.SAVE_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mesajKaldirData.dialog" max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>
          {{ $t("DESTEK.DELETE_MESSAGE_DIALOG.TITLE") }}
        </v-card-title>
        <v-card-text>{{ $t("DESTEK.DELETE_MESSAGE_DIALOG.INFO_CONTENT") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="mesajKaldirData.dialog = false">
            {{ $t("DESTEK.DELETE_MESSAGE_DIALOG.CANCEL_BTN") }}
          </v-btn>
          <v-btn color="green darken-1" text :loading="mesajKaldirData.loading" @click="mesajKaldir()">
            {{ $t("DESTEK.DELETE_MESSAGE_DIALOG.YES_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import PanelTitle from "../../../components/PanelTitle.vue";
import { mapState } from "vuex";
import DestekService from "../../../services/DestekService";
import { DynamicScroller } from "vue-virtual-scroller";

export default {
  components: { PanelTitle, DynamicScroller },
  name: "DestekTalepleri",
  data() {
    return {
      yazilarTable: {
        headers: [
          { text: this.$t("DESTEK.LIST.TABLE_FIELDS.APPLICATION"), value: "tickettype", sortable: false },
          { text: this.$t("DESTEK.LIST.TABLE_FIELDS.TITLE"), value: "ticketname", sortable: false, width: 300 },
          { text: this.$t("DESTEK.LIST.TABLE_FIELDS.USER"), value: "username", sortable: false },
          { text: this.$t("DESTEK.LIST.TABLE_FIELDS.DATE"), value: "ticketdate", sortable: false },
          {
            text: this.$t("DESTEK.LIST.TABLE_FIELDS.STATUS"),
            value: "ticketpublish",
            sortable: false,
            align: "center"
          },
          {
            text: this.$t("DESTEK.LIST.TABLE_FIELDS.ACTIONS"),
            value: "ticketcode",
            sortable: false,
            align: "center"
          }
        ],
        noDataText: this.$t("DESTEK.LIST.NO_TICKETS_FOUND"),
        loadingText: this.$t("DESTEK.LIST.LOADING_TICKETS")
      },
      secilenTalepler: [],
      pagination: {
        page: 1,
        lastPage: 0
      },
      tableParams: {
        page: 1,
        pageCount: 0,
        listStatus: true
      },
      list: {
        start: 0,
        limit: 10
      },
      listStatus: true,
      statusType: 0,
      statusDate: "",
      statusDateDialog: false,
      talepDialog: {
        dialog: false,
        overlay: false,
        message: "",
        scrollContainer: ""
      },
      talepDetayData: [],
      aktifTalepData: "",
      talepDetayLoading: false,
      talepDurumlarLoading: false,
      talepDurumLoading: [],
      mesajDuzenleData: {
        dialog: false,
        code: 0,
        message: "",
        loading: false
      },
      mesajKaldirData: {
        dialog: false,
        code: 0,
        loading: false
      },
      talepDetayRequest: {
        data: [],
        dialog: false
      }
    };
  },
  computed: {
    ...mapState({
      destekTalepleri: state => state.Destek.DestekTalepleri.destekTalepleri,
      destekTalepleriSayisi: state => state.Destek.DestekTalepleri.destekTalepleriSayisi
    })
  },
  methods: {
    pageClick(page) {
      if (page !== this.pagination.lastPage) {
        /**
         * Başlangıç değerini pagination'a göre ayarla
         */
        this.list.baslangic = this.pagination.page * this.list.limit - this.list.limit;

        this.talepListesi();
      }
    },
    groupColor() {
      switch (this.statusType) {
        case 1:
          return "amber darken-3";
        case 2:
          return "light-blue darken-3";
        case 3:
          return "success darken-1";
        case 4:
          return "black";
      }
    },
    talepListesi() {
      let params = {};

      /**
       * Params: musterID girili olduğunda sadece ilgili müşteriye ait olan
       * talepleri getir, yok ise normal listeyi getir.
       */
      if (this.$route.params.musterID) {
        params["user"] = this.$route.params.musterID;
      }

      this.tableParams.listStatus = true;

      params["status"] = this.statusType;
      if (this.statusDate) {
        params["date"] = new Date(this.statusDate).toISOString().slice(0, 10) + " 00:00:00";
      }
      params["start"] = this.list.start;
      params["limit"] = this.list.limit;

      this.$store.dispatch("Destek/DestekTalepleri/destekTalepleri", { ...params }).then(() => {
        this.tableParams.listStatus = false;
      });
    },
    talepDetay(talepCode) {
      this.$set(this, "talepDetayLoading", true);
      this.$set(this.talepDialog, "overlay", true);
      DestekService.talepMesajlar(talepCode)
        .then(res => {
          if (res.status === 200) {
            this.aktifTalepData = this.destekTalepleri.filter(t => t.ticketcode === talepCode)[0];
            this.talepDetayData = res.data;
            this.talepDialog.dialog = true;
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.$set(this, "talepDetayLoading", false);
        });
    },
    mesajGonder() {
      let talepCode = this.aktifTalepData.ticketcode,
        message = this.talepDialog.message;

      DestekService.mesajGonder({ talepCode, message })
        .then(res => {
          if (res.status === 200) {
            this.talepDetayData.push(res.data);
            this.talepDialog.message = "";
            this.$set(this.aktifTalepData, "ticketpublish", 3);
            return this.$snotify.success(this.$t("DESTEK.NOTIFY.MESSAGE_SEND_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.setScroll();
        });
    },
    mesajDuzenle() {
      let mesajCode = this.mesajDuzenleData.code,
        message = this.mesajDuzenleData.message;

      this.$set(this.mesajDuzenleData, "loading", true);
      DestekService.mesajDuzenle({ mesajCode, message })
        .then(res => {
          if (res.status === 200) {
            this.talepDetayData = this.talepDetayData.map(t => {
              if (t.code === mesajCode) {
                return res.data;
              } else {
                return t;
              }
            });
            this.$set(this.mesajDuzenleData, "loading", false);
            return this.$set(this.mesajDuzenleData, "dialog", false);
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.setScroll();
        });
    },
    mesajDuzenleDialog(code, message) {
      this.mesajDuzenleData.code = code;
      this.mesajDuzenleData.message = message;
      this.$set(this.mesajDuzenleData, "dialog", true);
    },
    mesajKaldir() {
      let mesajCode = this.mesajKaldirData.code;
      this.$set(this.mesajKaldirData, "loading", true);
      DestekService.mesajKaldir({ mesajCode }).then(res => {
        if (res.status === 200) {
          this.talepDetayData = this.talepDetayData.filter(t => t.code !== mesajCode);
          this.$snotify.success(this.$t("DESTEK.NOTIFY.MESSAGE_DELETE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
          this.$set(this.mesajKaldirData, "loading", false);
          this.$set(this.mesajKaldirData, "dialog", false);
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        }
      });
    },
    mesajKaldirDialog(mesajCode) {
      this.mesajKaldirData.code = mesajCode;
      this.$set(this.mesajKaldirData, "dialog", true);
    },
    setMsgScroll() {
      let cTimeOut = setInterval(() => {
        let container = this.$refs.virtualScrollBody;
        if (container) {
          this.setScrollHeight(container);
          clearInterval(cTimeOut);
        }
      }, 500);
    },
    setScrollHeight(container) {
      let counter = 0;
      let interval = setInterval(() => {
        if (container.scrollTop === container.scrollHeight - container.offsetHeight) {
          this.$set(this.talepDialog, "overlay", false);

          clearInterval(interval);
        } else {
          container.scrollTop = container.scrollHeight - container.offsetHeight;
        }

        if (counter > 50) {
          self.closeTalepDialog();
        }

        counter++;
      }, 300);
    },
    setScroll() {
      let container = this.$refs.virtualScrollBody;
      console.log(container);
      container.scrollTop = container.scrollHeight - container.offsetHeight;
    },
    closeTalepDialog() {
      this.talepDialog.dialog = false;
      this.aktifTalepData = "";
      this.talepDetayData = [];
    },
    dateFormat(date) {
      return new Intl.DateTimeFormat(this.$store.state.Language.apiLanguage, {
        dateStyle: "long",
        timeStyle: "short"
      }).format(new Date(date));
    },
    durumDegis(durum) {
      let talepCode = this.aktifTalepData.ticketcode;
      this.$set(this.talepDurumLoading, durum, true);
      DestekService.destekDurumDegis({ talepCode, durum })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("DESTEK.NOTIFY.STATUS_CHANGE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.secilenTalepler = [];
            this.talepListesi();
            this.closeTalepDialog();
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.$set(this.talepDurumLoading, durum, false);
        });
    },
    durumlariDegis(durum) {
      let talepCodes = this.secilenTalepler.map(t => t.ticketcode);
      this.talepDurumlarLoading = true;
      DestekService.destekDurumlariDegis({ talepCodes, durum })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("DESTEK.NOTIFY.STATUSES_CHANGE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.secilenTalepler = [];
            this.talepListesi();
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.talepDurumlarLoading = false;
        });
    },
    mesajRequestDialog(request) {
      this.talepDetayRequest.data = request;
      this.$set(this.talepDetayRequest, "dialog", true);
    },
    setStatusDate() {
      this.$refs.dialog.save(this.statusDate);
      this.talepListesi();
    },
    parseIt(value) {
      return value.split("\n").join("<br>");
    }
  },
  watch: {
    "pagination.page": {
      handler(page) {
        this.pagination.lastPage = page;
      },
      immediate: true
    },
    "talepDialog.dialog"(val) {
      if (val) {
        this.setMsgScroll();
      }
    },
    statusType: {
      handler() {
        this.talepListesi();
      },
      immediate: true
    },
    statusDate(val) {
      if (!val) {
        this.talepListesi();
      }
    }
  }
};
</script>

<style>
#ticketTable .v-data-table-header {
  background: #212121 !important;
}

#ticketTable .v-data-table-header th {
  color: #fff !important;
}

#ticketTable .v-data-table-header .v-data-table__checkbox svg path {
  fill: white !important;
}

.ticket-message-actions {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
